var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.962467 0.282425C0.782119 0.467065 0.681152 0.714929 0.681152 0.973033C0.681152 1.23114 0.782119 1.479 0.962467 1.66364L11.0383 12L0.962467 22.3343C0.782119 22.5189 0.681152 22.7668 0.681152 23.0249C0.681152 23.283 0.782119 23.5309 0.962467 23.7155C1.05013 23.8055 1.15494 23.8771 1.27071 23.926C1.38648 23.9748 1.51087 24 1.63653 24C1.76219 24 1.88658 23.9748 2.00235 23.926C2.11813 23.8771 2.22294 23.8055 2.3106 23.7155L13.0253 12.7216C13.2135 12.5286 13.3189 12.2696 13.3189 12C13.3189 11.7304 13.2135 11.4714 13.0253 11.2784L2.3106 0.284493C2.22294 0.194459 2.11813 0.122899 2.00235 0.0740364C1.88658 0.0251741 1.76219 0 1.63653 0C1.51087 0 1.38648 0.0251741 1.27071 0.0740364C1.15494 0.122899 1.05013 0.194459 0.962467 0.284493V0.282425Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.8452885137590da5b14104b481fde05b.svg";
export { ForwardRef as ReactComponent };